export default "__VITE_ASSET__BDnVx_zO__"